// Libs
import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

// Assets
import noCar from "../../assets/noCar.jpg";

// Style
import style from './imageViewer.module.css';

const imageExt = process.env.REACT_APP_IMAGE_EXT;
const imageTemplateExt = process.env.REACT_APP_IMAGE_TEMPLATE_EXT;
const apiUrl = process.env.REACT_APP_API_URL;

const ImageViewer = ({ item }) => {

    let images = !item.images.length > 0 ? [{
      original: noCar,
      thumbnail: noCar,
    }] : [];

    for (let i = 0; i < item.images.length; i++) {
      images.push({
        original: `${apiUrl}/data/${item.id}/${item.images[i].fileName}.${imageExt}`,
        thumbnail: `${apiUrl}/data/${item.id}/templates/${item.images[i].fileName}.${imageTemplateExt}?width=100`,
      });
    };

    const renderLeftNav = (onClick, disabled) => (
      <button
        type="button"
        className={`${style.customNav} ${style.customLeftNav}`}
        disabled={disabled}
        onClick={onClick}
      >
        <svg viewBox="0 0 24 24">
          <path d="M15.41 16.58L10.83 12l4.58-4.58L14 6l-6 6 6 6z" />
        </svg>
      </button>
    );

    const renderRightNav = (onClick, disabled) => (
      <button
        type="button"
        className={`${style.customNav} ${style.customRightNav}`}
        disabled={disabled}
        onClick={onClick}
      >
        <svg viewBox="0 0 24 24">
          <path d="M8.59 16.58L13.17 12 8.59 7.42 10 6l6 6-6 6z" />
        </svg>
      </button>
    );

    const renderFullscreenButton = (onClick, isFullscreen) => (
      <button
        type="button"
        className={style.customFullscreenButton}
        onClick={onClick}
      >
        <svg viewBox="0 0 448 512">
          {!isFullscreen ? (
            <path d="M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"/>
          ) : (
            <path d="M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"/>
          )}
        </svg>
      </button>
    );

    return (
        <ImageGallery
          items={images}
          lazyLoad={true}
          renderLeftNav={renderLeftNav}
          renderRightNav={renderRightNav}
          renderFullscreenButton={renderFullscreenButton}
          showPlayButton={false}
        />
    );
};

export default ImageViewer;